import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { CONTRIBUTOR_UPLOAD_ACCESS } from '../../../../../../../../constants/contributors';
import Button from '../../../../../../../../components/global/Button';
import CustomControl from '../../../../../../../../components/global/CustomControl';

const propTypes = {
  currentUploadAccess: PropTypes.oneOf(Object.keys(CONTRIBUTOR_UPLOAD_ACCESS)),
  onPublish: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  isPublishing: PropTypes.bool,
};

const SlideshowUploadAccess = ({
  currentUploadAccess,
  onPublish,
  onSuccess,
  isPublishing = true,
}) => {
  const [saving, setSaving] = useState(false);
  const [uploadAccess, setUploadAccess] = useState(
    currentUploadAccess ?? CONTRIBUTOR_UPLOAD_ACCESS.NONE,
  );

  const onConfirm = async () => {
    if (saving) {
      return;
    }

    try {
      setSaving(true);
      await onPublish({ uploadAccess });
      onSuccess();
    } finally {
      setSaving(true);
    }
  };
  return (
    <Fragment>
      <h4 className="text-center">Almost there...</h4>
      <p className="text-dark text-bold">
        After {isPublishing ? 'publishing' : 'unpublishing'}, how do you want
        new uploads to be handled?
      </p>
      <CustomControl
        id="no-upload"
        type="checkbox"
        name="no-upload"
        label="Prevent others from adding additional photos."
        checked={uploadAccess === CONTRIBUTOR_UPLOAD_ACCESS.NONE}
        onChange={() => setUploadAccess(CONTRIBUTOR_UPLOAD_ACCESS.NONE)}
        className="checkbox-require-photo-approval lh-normal mb-1"
      />
      <CustomControl
        id="upload-review"
        type="checkbox"
        name="upload-review"
        label="Allow others to upload, but let me review the photos before publishing to the Memories Slideshow."
        checked={uploadAccess === CONTRIBUTOR_UPLOAD_ACCESS.REVIEW}
        onChange={() => setUploadAccess(CONTRIBUTOR_UPLOAD_ACCESS.REVIEW)}
        className="checkbox-require-photo-approval lh-normal mb-1"
      />
      <CustomControl
        id="upload-all"
        type="checkbox"
        name="no-upload"
        label="Allow others to add additional photos to Memories Slideshow without my review."
        checked={uploadAccess === CONTRIBUTOR_UPLOAD_ACCESS.PUBLISH}
        onChange={() => setUploadAccess(CONTRIBUTOR_UPLOAD_ACCESS.PUBLISH)}
        className="checkbox-require-photo-approval lh-normal"
      />
      <div className="text-center">
        <Button onClick={onConfirm} className="mt-2" disabled={saving}>
          {saving
            ? 'Saving...'
            : `Confirm and ${isPublishing ? 'publish' : 'unpublish'}`}
        </Button>
      </div>
    </Fragment>
  );
};

SlideshowUploadAccess.propTypes = propTypes;

export default SlideshowUploadAccess;
